module.exports = __webpack_public_path__ + "img/Our_work_2.9b19f849.png";